@if (ifeFormat) {
  <div class="row cl-spacing-small" [formGroup]="form">
    @if (form.controls.license_expiration_date) {
      <div class="col-6">
        <label for="license_expiration_date" class="form-label">License Expiration Date<span
        class="required">*</span></label>
        <input id="license_expiration_date" type="text" formControlName="license_expiration_date">
        @if (form.controls.license_expiration_date.errors?.required) {
          <p class="invalid-feedback">This field is
          required.</p>
        }
        @if (!form.controls.license_expiration_date.errors) {
          <p class="valid-feedback">Insert the Nicemedia specific
          license expiration date</p>
        }
      </div>
    }
    <!-- Delta Flytedge -->
    @if (form.controls.dfe_ca_bits) {
      <div class="col-6">
        <label for="dfe_ca_bits" class="form-label">CA bits<span class="required">*</span></label>
        <select id="dfe_ca_bits" class="form-select" formControlName="dfe_ca_bits">
          <option [value]="'48'">
            48 Bits
          </option>
          <option [value]="'24'">
            24 Bits
          </option>
          <option [value]="'0'">
            Disabled
          </option>
        </select>
        @if (form.controls.dfe_ca_bits.errors?.required) {
          <p class="invalid-feedback">This field is
          required.</p>
        }
        @if (!form.controls.dfe_ca_bits.errors) {
          <p class="valid-feedback">Number of bits for content armor. 24 or 48,
          anything else disables content armor</p>
        }
      </div>
    }
    @if (form.controls.dfe_key_id) {
      <div class="col-6">
        <label for="dfe_key_id" class="form-label">DRM Key ID<span class="required">*</span></label>
        <input id="dfe_key_id" type="text" formControlName="dfe_key_id">
        @if (form.controls.dfe_key_id.errors?.required) {
          <p class="invalid-feedback">This field is
          required.</p>
        }
        @if (!form.controls.dfe_key_id.errors) {
          <p class="valid-feedback">DRM Key ID</p>
        }
      </div>
    }
    @if (form.controls.dfe_key) {
      <div class="col-6">
        <label for="dfe_key" class="form-label">DRM Key<span class="required">*</span></label>
        <input id="dfe_key" type="text" formControlName="dfe_key">
        @if (form.controls.dfe_key.errors?.required) {
          <p class="invalid-feedback">This field is
          required.</p>
        }
        @if (!form.controls.dfe_key.errors) {
          <p class="valid-feedback">DRM Key</p>
        }
      </div>
    }
    @if (form.controls.dfe_iv) {
      <div class="col-6">
        <label for="dfe_iv" class="form-label">DRM Key IV<span class="required">*</span></label>
        <input id="dfe_iv" type="text" formControlName="dfe_iv">
        @if (form.controls.dfe_iv.errors?.required) {
          <p class="invalid-feedback">This field is
          required.</p>
        }
        @if (!form.controls.dfe_iv.errors) {
          <p class="valid-feedback">DRM IV</p>
        }
      </div>
    }
    @if (form.controls.dfe_disable_drm) {
      <div class="col-6">
        <label for="dfe_disable_drm" class="form-label">Disable DRM<span class="required">*</span></label>
        <select id="dfe_disable_drm" class="form-select" formControlName="dfe_disable_drm">
          <option [value]="'0'">
            DRM enabled (0)
          </option>
          <option [value]="'1'">
            DRM disabled (1)
          </option>
        </select>
        @if (form.controls.dfe_disable_drm.errors?.required) {
          <p class="invalid-feedback">This field is
          required.</p>
        }
        @if (!form.controls.dfe_disable_drm.errors) {
          <p class="valid-feedback">Disable DRM? "1" disables it, anything else
          enables it</p>
        }
      </div>
    }
    <!-- Delta Flytedge END -->
    @if (form.controls.preroll) {
      <div class="col-4">
        <label for="preroll" class="form-label">Preroll URL</label>
        <input id="preroll" type="text" formControlName="preroll">
        @if (form.controls.preroll.errors?.required) {
          <p class="invalid-feedback">This field is
          required.</p>
        }
        @if (!form.controls.preroll.errors) {
          <p class="valid-feedback">URL to preroll to prepended for Mezzanine
          deliveries</p>
        }
      </div>
    }
    @if (form.controls.card_url) {
      <div class="col-4">
        <label for="card_url" class="form-label">Title Card URL</label>
        <input id="card_url" type="text" formControlName="card_url">
        @if (form.controls.card_url.errors?.required) {
          <p class="invalid-feedback">This field is
          required.</p>
        }
        @if (!form.controls.card_url.errors) {
          <p class="valid-feedback">URL to a title card image</p>
        }
      </div>
    }
    @if (form.controls.card_duration) {
      <div class="col-4">
        <label for="card_duration" class="form-label">Title Card Duration</label>
        <input id="card_duration" type="text" formControlName="card_duration">
        @if (form.controls.card_duration.errors?.required) {
          <p class="invalid-feedback">This field is
          required.</p>
        }
        @if (form.controls.card_duration.errors) {
          <p class="valid-feedback">Duration of title card display</p>
        }
      </div>
    }
    @if (form.controls.generate_webvtt) {
      <div class="col-6">
        <div class="form-check">
          <label for="generate_webvtt" class="form-check-label">Create WebVTT subtitles/CC for Avant Up</label>
          <input id="generate_webvtt" type="checkbox" class="form-check-input" formControlName="generate_webvtt">
        </div>
      </div>
    }
    @if (form.controls.video_bitrate) {
      <div class="col-4">
        <label for="video_bitrate" class="form-label">Override video bit rate</label>
        <input id="video_bitrate" type="number" formControlName="video_bitrate">
        @if (form.controls.video_bitrate.errors?.min || form.controls.video_bitrate.errors?.max) {
          <p
            class="invalid-feedback">
            Must be between 1Mbit and 100Mbit.
          </p>
        }
        @if (!form.controls.video_bitrate.errors) {
          <p class="valid-feedback">Set a specific video bit rate</p>
        }
      </div>
    }
    <!-- Lilt Translation (item-level: target languages + reference URLs).
         Domain and source language are picked at PO level — see DefaultPoComponent. -->
    @if (form.controls.lilt_language_pairs) {
      <div class="col-12 align-self-start">
        <label class="form-label">Target Languages<span class="required">*</span></label>
        @if (!liltDomain) {
          <p class="form-text">Pick a Lilt domain (top of the form) first.</p>
        } @else if (liltAvailableModels.length === 0) {
          <p class="invalid-feedback d-block">This domain has no en-US source models. Pick a different domain.</p>
        } @else {
          <div>
            @for (m of liltAvailableModels; track m.memory_id) {
              <label class="form-check form-check-inline" style="margin-right: 16px;">
                <input type="checkbox" class="form-check-input"
                       [checked]="isModelSelected(m)"
                       (change)="toggleModel(m)">
                <span class="form-check-label">{{ formatModelLabel(m) }}</span>
              </label>
            }
          </div>
          @if (form.controls.lilt_language_pairs.errors?.required) {
            <p class="invalid-feedback d-block">Pick at least one target language.</p>
          }
        }
      </div>
    }
    @if (form.controls.lilt_reference_urls) {
      <div class="col-12">
        <label for="lilt_reference_urls" class="form-label">Reference files (S3 URLs)</label>
        <textarea id="lilt_reference_urls" class="form-control" rows="3"
          formControlName="lilt_reference_urls"
          placeholder="s3://bucket/path/script.pdf&#10;s3://bucket/path/glossary.txt"></textarea>
        @if (form.controls.lilt_reference_urls.errors?.invalidS3Url) {
          <p class="invalid-feedback">Each line must be an s3:// URL.</p>
        }
        @if (!form.controls.lilt_reference_urls.errors) {
          <p class="valid-feedback">One s3:// URL per line. Files are copied to the publish bucket and uploaded to Lilt as REFERENCE.</p>
        }
      </div>
    }
    <!-- Lilt Translation END -->
    @if (form.controls.dyn_subtitle_position) {
      <div class="col-6">
        <label for="dyn_subtitle_position" class="form-label">Dynamic Subtitle Position</label>
        <select id="dyn_subtitle_position" class="form-select" formControlName="dyn_subtitle_position">
          <option [value]="''">Default (Bottom)</option>
          <option [value]="'bottom'">Bottom</option>
          <option [value]="'top'">Top</option>
          <option [value]="'source'">Source (follow source position)</option>
        </select>
        <p class="valid-feedback">Override where dynamic subtitles are positioned. Leave as
        Default to use the encoder's standard placement (bottom).</p>
      </div>
    }
    @if (form.controls.thales_fastpath_airline) {
      <div class="col-4">
        <label for="thales_fastpath_airline" class="form-label">Thales fast-path airline</label>
        <input id="thales_fastpath_airline" type="text" minlength="3" maxlength="3"
          formControlName="thales_fastpath_airline">
        @if (form.controls.thales_fastpath_airline.errors?.required) {
          <p class="invalid-feedback">This field is
          required.</p>
        }
        @if (!form.controls.thales_fastpath_airline.errors) {
          <p class="valid-feedback">ICAO airline code for Thales
          destination</p>
        }
      </div>
    }
  </div>
}
